import { render, staticRenderFns } from "./ProductTabsContent.vue?vue&type=template&id=4011220a&scoped=true&"
import script from "./ProductTabsContent.vue?vue&type=script&lang=js&"
export * from "./ProductTabsContent.vue?vue&type=script&lang=js&"
import style0 from "./ProductTabsContent.vue?vue&type=style&index=0&id=4011220a&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4011220a",
  null
  
)

export default component.exports